import React, {useState, useEffect} from 'react';
import { UUIDUtil } from '@aperza/util';
import CatalogCluezDownloadModal from './CatalogCluezDownloadModal';
import useReactiveMessage from '../../hook/UseReactiveMessage';

const CatalogCluezDownloadModalLoader = (props) => {

  const [catalog, setCatalog] = useState({
    requestId: undefined,
    companyId: undefined,
    catalogId: undefined,
  });

  let subscription;
  const {getMessage} = useReactiveMessage('CATALOG_DOWNLOAD_CLUEZ');

  useEffect(() => {
    subscription = getMessage().subscribe(message => {
      if (message && message.companyId && message.catalogId) {
        setCatalog({
          requestId: UUIDUtil.uuid(),
          companyContractDisplayId: message.companyContractDisplayId,
          companyId: +message.companyId,
          catalogId: +message.catalogId,
          catalogPreview: message.catalogPreview,
        });
      }
    });

    let elements = document.getElementsByClassName('catalogDownloadLink');
    elements.forEach(el => {
      el.addEventListener('click', (event) => {
        let source = event.currentTarget;
        if (source && source.dataset.company_id && source.dataset.catalog_id) {
          event.preventDefault();

          setCatalog({
            requestId: UUIDUtil.uuid(),
            companyContractDisplayId: parseInt(source.dataset.company_contract_display_id),
            companyId: parseInt(source.dataset.company_id),
            catalogId: parseInt(source.dataset.catalog_id),
          });
        }
      })
    });

    window.aperza.aw.catalogCluezDownloadModalLoader = new Date().getTime();

  }, []);

  return (
    <CatalogCluezDownloadModal requestId={catalog.requestId}
      catalogId={catalog.catalogId}
                               companyId={catalog.companyId} />
  )

};

export default CatalogCluezDownloadModalLoader;

